import { SpinnerLegacy } from "../../../components";
import { Dialog } from "../../../components/modal/Dialog";
import { useOrder } from "../../../hooks/api/v2/order/useOrder";
import { ConfirmOrderForm } from "./ConfirmOrderForm";
import { SupplierInvoiceCreationStageType } from "@sellar-io/api-v2/types";
import { ConfirmOrderDialogPage } from "./ConfirmOrderDialog.shared";

type ConfirmOrderDialogProps = {
  active: boolean;
  onDismiss: () => void;
  orderId: number;
  invoiceCreationStage: SupplierInvoiceCreationStageType;
  onSuccess?: () => void;
};

export const ConfirmOrderDialog = (props: ConfirmOrderDialogProps) => {
  return (
    <Dialog
      active={props.active}
      onDismiss={props.onDismiss}
      initPage={ConfirmOrderDialogPage.FORM}
    >
      <ConfirmOrderDialogContent {...props} />
    </Dialog>
  );
};

const ConfirmOrderDialogContent = ({
  orderId,
  onDismiss,
  onSuccess,
  invoiceCreationStage,
}: ConfirmOrderDialogProps) => {
  const orderQuery = useOrder(orderId);
  return (
    <>
      {orderQuery.isLoading ? (
        <SpinnerLegacy />
      ) : (
        <>
          {orderQuery.data && (
            <ConfirmOrderForm
              order={orderQuery.data}
              onDismiss={onDismiss}
              invoiceCreationStage={invoiceCreationStage}
              onSuccess={onSuccess}
            />
          )}
        </>
      )}
    </>
  );
};
